import { useEffect, useState } from "react";
import { useApiContext } from 'context/ApiContext';

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import 'leaflet/dist/leaflet.css';

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDPopup from "components/MDPopup";

// Material Dashboard 2 React example components
import DataTable from "examples/Tables/DataTableV2";

function ParkTab({ parks }) {
    const { parkFormInfosAdm, setParkFormInfosAdm, APIRequestType, getAPI } = useApiContext();

    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null); // Peut contenir un user ou park à supprimer

    const handleOpenDeleteDialog = (item) => {
        setSelectedItem(item);
        setOpenDeleteDialog(true);
    };

    const handleCloseDeleteDialog = () => {
        setSelectedItem(null);
        setOpenDeleteDialog(false);
    };

    const handleConfirmDelete = () => {
        // Ici tu peux appeler l'API pour supprimer, par exemple :
        // deleteAPI(APIRequestType.DELETE_USER, selectedItem.id);
        console.log("Delete item:", selectedItem);

        // Fermer la popup après suppression
        setOpenDeleteDialog(false);
    };

    const handleCreatePark = () => {
        setParkFormInfosAdm({
            selectedPark: null,
            formType: "CreatePark",
        });
        console.log("Selected PARK to Create");
    };
    const handleModifyPark = (item) => {
        setParkFormInfosAdm({
            selectedPark: item,
            formType: "ModifyPark",
        });
        console.log("Selected PARK to Modify:", item);
    };
    const handleVisualizePark = (item) => {
        setParkFormInfosAdm({
            selectedPark: item,
            formType: "VisualizePark",
        });
        console.log("Selected PARK to Visualize:", item);
    };

    return (
        <MDBox pt={4} pb={3}>
            <Grid container spacing={6}>
                <Grid item xs={12}>
                    <Card>
                        <MDBox
                            mx={2}
                            mt={-3}
                            py={1.5}
                            px={2}
                            variant="gradient"
                            bgColor="info"
                            borderRadius="lg"
                            coloredShadow="info"
                        >
                            <MDTypography variant="h6" color="white"> Parks </MDTypography>
                        </MDBox>
                        <MDBox pt={2} pr={2} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <MDButton
                                onClick={() => handleCreatePark()}
                                sx={{
                                    '&:hover': {
                                        backgroundColor: "#b7e4fd", // Couleur au survol
                                    },
                                }}
                            >
                                <MDBox
                                    sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                                >
                                    <MDTypography
                                        variant="h7"
                                        color="dark"
                                        fontWeight="medium"
                                        sx={{ mt: 0.2 }}
                                    >
                                        ADD NEW
                                    </MDTypography>
                                    <Icon color="text" fontSize="large" sx={{ mt: -0.1 }}> add </Icon>
                                </MDBox>
                            </MDButton>
                        </MDBox>
                        <MDBox>
                            <DataTable
                                table={{
                                    columns: [
                                        { Header: "Name", accessor: "name", align: "left" },
                                        { Header: "Address", accessor: "address", align: "left" },
                                        { Header: "", accessor: "state", align: "center" },
                                        { Header: "", accessor: "icon", align: "right" },
                                    ],
                                    rows: parks.length === 0
                                        ? [{
                                            nameValue: "...",
                                            name: (
                                                <MDTypography component="span" variant="caption" color="text" fontWeight="medium">
                                                    ...
                                                </MDTypography>
                                            ),
                                        }]
                                        : parks.map((park) => ({ // Utilisation de "park" ici
                                            nameValue: park.name,
                                            addressValue: park.address,
                                            state: park.validatedChanges,

                                            name: (
                                                <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
                                                    {park.name}
                                                </MDTypography>
                                            ),
                                            address: (
                                                <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
                                                    {park.address}
                                                </MDTypography>
                                            ),
                                            state: (
                                                park.validatedChanges === "1" ? null : (
                                                    <MDTypography component="a" href="#" variant="caption" color="error" fontWeight="medium">
                                                        Parameters update is running.
                                                    </MDTypography>
                                                )
                                            ),
                                            icon: (
                                                <MDBox>
                                                    {/*<Icon
                                                    fontSize="small"
                                                    sx={{ mt: -0.25, mr: 3, '&:hover': { color: "#b7e4fd", cursor: "pointer" } }}
                                                    onClick={() => handleOpenDeleteDialog(park)} // Passer "park" ici
                                                >
                                                    delete
                                                </Icon>*/}
                                                    <Icon
                                                        fontSize="small"
                                                        sx={{ mt: -0.25, mr: 3, '&:hover': { color: "#b7e4fd" } }}
                                                        onClick={() => handleModifyPark(park)}
                                                    >
                                                        drive_file_rename_outline
                                                    </Icon>
                                                    <Icon
                                                        fontSize="small"
                                                        sx={{ mt: -0.25, '&:hover': { color: "#b7e4fd" } }}
                                                        onClick={() => handleVisualizePark(park)}
                                                    >
                                                        visibility
                                                    </Icon>
                                                </MDBox>
                                            ),
                                        })),
                                }}
                                rowsNumberPerPage={7}
                                isSorted={false}
                                entriesPerPage={false}
                                showTotalEntries={false}
                                noEndBorder
                            />
                        </MDBox>
                    </Card>
                </Grid>
            </Grid>

            <MDPopup
                open={openDeleteDialog}
                onClose={handleCloseDeleteDialog}
                onConfirm={handleConfirmDelete}
                item={selectedItem}
                title="Confirm Deletion"
                body={(item) => (
                    <>
                        Are you sure you want to delete the park <strong>{item?.name}</strong> located at <strong>{item?.address}</strong>?
                    </>
                )}
                confirmLabel="Delete"
                cancelLabel="Cancel"
            />
        </MDBox >
    );
}

export default ParkTab;